import React from 'react';

import { useIntl } from 'react-intl';
import { useSelectedCar } from 'features/myFleet';
import { useNavigationOperations } from 'entities/navigation';
import { useApplicationOperations } from 'entities/application';
import { useHistoryTargetDeviceContext } from 'pages/Map/context/historyTargetDevice';
import { useStyles } from './styles';

import { Button } from 'e100-react-components';
import { Icon } from 'components';

export const RouteHistoryButton = () => {
  const { formatMessage } = useIntl();
  const classes = useStyles();
  const { setHistoryTarget } = useHistoryTargetDeviceContext();
  const { setActiveMenuItem, resetActiveModals } = useApplicationOperations();
  const { getNavigationAutos } = useNavigationOperations();
  const selectedCar = useSelectedCar()!;

  const onCLickHistory = () => {
    const { licensePlate } = selectedCar.currentVehicle;
    resetActiveModals();
    setHistoryTarget(null, {
      key: licensePlate,
      obuNumber: selectedCar.obuNumber,
      value: `${licensePlate} (${selectedCar.obuNumber})`
    });
    getNavigationAutos(() => {
      setActiveMenuItem('history');
    });
  };

  return (
    <Button
      endIcon={<Icon kind="next" />}
      classes={{
        root: classes.button,
        label: classes.buttonNavigateLabel,
      }}
      onClick={onCLickHistory}
    >
      {formatMessage({ id: 'routesHistory' })}
    </Button>
  );
};
